<script setup>
import { isVNode, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import Policy from 'dashboard/components/policy.vue';
import { useSidebarContext } from './provider';

const props = defineProps({
  label: { type: String, required: true },
  to: { type: [String, Object], required: true },
  icon: { type: [String, Object], default: null },
  active: { type: Boolean, default: false },
  component: { type: Function, default: null },
});

const { resolvePermissions, resolveFeatureFlag } = useSidebarContext();

const shouldRenderComponent = computed(() => {
  return typeof props.component === 'function' || isVNode(props.component);
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Policy
    :permissions="resolvePermissions(to)"
    :feature-flag="resolveFeatureFlag(to)"
    as="li"
    class="relative py-0.5 ltr:ml-3 rtl:mr-3 ltr:pl-3 rtl:pr-3 child-item before:left-0 before:bg-n-weak/60 rtl:before:right-0 after:bg-transparent after:border-n-weak/60 text-n-slate-11"
  >
    <component
      :is="to ? 'router-link' : 'div'"
      :to="to"
      :title="label"
      class="group relative flex h-8 min-w-0 items-center gap-2.5 rounded-md px-2.5 outline-none transition-colors focus-visible:ring-2 focus-visible:ring-n-brand/40"
      :class="{
        'bg-n-brand/10 text-n-brand font-medium active': active,
        'hover:bg-n-slate-3 hover:text-n-slate-12': !active,
      }"
    >
      <component
        :is="component"
        v-if="shouldRenderComponent"
        :label
        :icon
        :active
      />
      <template v-else>
        <Icon v-if="icon" :icon="icon" class="size-4 shrink-0" />
        <div
          class="min-w-0 flex-1 truncate text-[13px] leading-5 tracking-tight"
        >
          {{ label }}
        </div>
      </template>
    </component>
  </Policy>
</template>
